var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PageListTemplate',{attrs:{"title":_vm.title,"mod":_vm.mod,"cols":_vm.cols,"params":_vm.params},scopedSlots:_vm._u([{key:"item",fn:function(ref){
var item = ref.item;
return [_c(_vm.cardComponent,_vm._b({tag:"component",attrs:{"base-path":_vm.basePath,"type":_vm.cardType}},'component',item,false))]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }